import { createTheme } from '@mui/material/styles'

// Refined Slate & Sky Blue Palette
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#38bdf8', // Sky 400
      dark: '#0284c7',
      light: '#7dd3fc',
      contrastText: '#0f172a'
    },
    secondary: {
      main: '#94a3b8', // Slate 400
      dark: '#475569',
      light: '#cbd5e1'
    },
    background: {
      default: '#0f172a', // Slate 900
      paper: '#1e293b' // Slate 800
    },
    text: {
      primary: '#f8fafc', // Slate 50
      secondary: '#94a3b8' // Slate 400
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    action: {
      selected: 'rgba(255, 255, 255, 0.9)' // White background for booking badges
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    allVariants: {
      color: '#f8fafc'
    },
    subtitle2: {
      color: '#38bdf8'
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 500
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e293b',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#334155'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#475569'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#38bdf8'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: '8px',
          boxShadow:
            '0 0 20px rgba(56, 189, 248, 0.1), 0 4px 12px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#f8fafc',
          '&:hover': {
            backgroundColor: 'rgba(56, 189, 248, 0.08)'
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(56, 189, 248, 0.16)',
            '&:hover': {
              backgroundColor: 'rgba(56, 189, 248, 0.24)'
            }
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#94a3b8',
          '&.Mui-checked': {
            color: '#38bdf8'
          }
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '.booking-badge': {
          backgroundColor: '#333',
          color: '#d4d4d4',
          border: '1px solid #d4d4d4'
        },
        '.calendar-controls': {
          backgroundColor: 'rgba(255, 255, 255, 0.05)'
        },
        '.booking-expand-chip': {
          backgroundColor: '#38bdf8 !important',
          color: '#0f172a !important',
          '&:hover': {
            backgroundColor: '#7dd3fc !important'
          }
        },
        '.office-drawing-editor': {
          minHeight: '400px',
          backgroundColor: '#1e293b',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
          overflow: 'hidden'
        },
        '.office-drawing-viewer': {
          minHeight: '300px',
          backgroundColor: '#1e293b',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
          overflow: 'hidden'
        }
      }
    }
  }
})

export default darkTheme
